export default "__VITE_ASSET__BfXQyicr__ 584w";